import { Component, OnInit, HostListener } from "@angular/core";
import { appConstants } from "src/app/constants/appConstants";
import { CommonService } from "src/app/services/common.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-refund-request",
  templateUrl: "./refund-request.component.html",
  styleUrls: ["./refund-request.component.scss"],
})
export class RefundRequestComponent implements OnInit {
  constructor(
    private _commonService: CommonService,
    private _toasterService: ToastrService
  ) {}
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  reason: string = "";
  search: any = {
    phone: "",
    paymentId: "",
    // refundId: "",
  };
  pageLimit: number[] = [5, 10, 25, 50, 100];
  checkedBtn: any = [];
  page: number = 1;
  total_page: number = 1;
  pageSize: number = 50;
  selectedRequest: Array<any> = [];
  refundRequestList: Array<any> = [];
  @HostListener("window:scroll")
  ngOnInit() {
    this.getVerificationList(this.page - 1);
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }
  Search(key) {
    let url = appConstants.FILTER + "?page=0&status=PENDING_VERIFICATION&";
    switch (key) {
      case "phone":
        url = url + "filterType=phone&filterKey=" + this.search.phone;
        break;
      case "paymentId":
        url = url + "filterType=paymentId&filterKey=" + this.search.paymentId;
        break;
    }
    this.getApiRequest(url);
  }

  getVerificationList(page) {
    let url = appConstants.REFUND_REQUEST + page + "&pageSize=" + this.pageSize;
    this.getApiRequest(url);
  }
  changePageSize() {
    this.getVerificationList(this.page - 1);
  }
  getApiRequest(url) {
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.refundRequestList = res.refundsInfo;
        res.refundsInfo.map((ele, index) => {
          this.checkedBtn[index] = false;
        });
        this.total_page = res.totalPages * this.pageSize;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
  getPageFromService(page) {
    if (page) {
      this.getVerificationList(page - 1);
    }
  }
  updateStatus() {
    let url = appConstants.UPDATE_STATUS;
    if (this.selectedRequest[0]) {
      this._commonService.Reasonvalue("", "Edit").subscribe((res) => {
        if (res != true) {
          const data = {
            id: this.selectedRequest[0],
            updatedBy: localStorage.getItem(appConstants.USER_NAME),
            reason: res,
          };
          this._commonService.PutRequest(data, url).subscribe(
            (res) => {
              this._toasterService.success(
                "status successfully updated",
                "Success",
                {
                  timeOut: 1000,
                }
              );
              this.selectedRequest = [];

              this.getVerificationList(this.page - 1);
            },
            (err) => {
              if (err.status == 403) {
                this._toasterService.warning(
                  "you don't have permission request to refund"
                );
              } else {
                this._toasterService.warning(err.error.message);
              }
            }
          );
        }
      });
    } else {
      this._toasterService.warning("please  select one row for update");
    }
  }
  checkedorder(event, id, i) {
    if (event.checked) {
      if (this.selectedRequest.length < 1) {
        this.selectedRequest.push(id);
      } else {
        setTimeout(() => {
          this.checkedBtn[i] = false;
        });
        this._toasterService.warning("you can select only one row for update");
      }
    } else {
      this.selectedRequest = [];
    }
  }
}
